"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeAreaTick = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var colors_1 = require("../../styles/colors");
var string_1 = require("../../util/string");
function RangeAreaTick(props) {
    var _a, _b;
    var _c = props.viewBox, x = _c.x, y = _c.y, width = _c.width, referenceArea = props.referenceArea;
    var nameLines = string_1.splitIntoLines(referenceArea.name, Math.floor(width / 10));
    var fill = ((_b = (_a = referenceArea.tickColor) !== null && _a !== void 0 ? _a : referenceArea.fillColor) !== null && _b !== void 0 ? _b : colors_1.blue.c60) || 'none';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("text", { x: x, y: y, dx: 15, dy: -15, textAnchor: 'middle', fill: fill, style: { fontWeight: 'bold' } }, nameLines.map(function (namePart, i) {
            return namePart && (react_1.default.createElement("tspan", { key: namePart, dx: width / 2, dy: (nameLines.length - i) * -15, x: x, y: y, textAnchor: 'middle' }, namePart));
        })),
        react_1.default.createElement(recharts_1.Rectangle, { x: x, y: y - 7, width: width, height: 4, fill: fill })));
}
exports.RangeAreaTick = RangeAreaTick;
//# sourceMappingURL=RangeAreaTick.js.map